module.exports = __webpack_public_path__ + "static/power1-3-b491bd0a29ebeba1f8197cbe739609b9.png";